import React, {Component} from 'react';
import { Segment, Header, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';

import FormsHradminEmployeeAddClaimForm from '../../../component/forms/hradmin/employee/add_claim';
import {
    submitHradminEmployeeHrClaimData
} from '../../../actions';

class HradminEmployeeViewAddClaimPage extends Component {
    render() {
        const {uuid} = this.props.match.params;
        return (
            <Grid columns={1}>
                <Grid.Column>
                    <Header block attached="top">
                        Add Claim
                    </Header>
                    <Segment attached>
                        <FormsHradminEmployeeAddClaimForm 
                            claimOptions={this.props.claimOptions}
                            submitHradminEmployeeHrClaimData={this.props.submitHradminEmployeeHrClaimData}
                            user={this.props.user}
                            targetUserId={uuid}
                        />
                    </Segment>
                </Grid.Column>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return { 
        user: state.user.user,
        claimOptions: state.claimOptions.inpatientClaimOptions
    };
}

export default connect(mapStateToProps, {
    submitHradminEmployeeHrClaimData,
})(HradminEmployeeViewAddClaimPage);